import { Card, Tab, Tabs } from '@mui/material'
import Grid from '@mui/material/Grid'

// MD UI Dashboard PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import AppsOnboardingCategory from "../../AppsOnboardingCategory"
import AppsOnboarding from "../../AppsOnboarding"
import AppsChecklistCategory from "../../AppsChecklistCategory"
import AppsMediaCategory from "../../AppsMediaCategory"
import AppsMedia from "../../AppsMedia"
import FaqCategory from "../../FaqCategory"
import FaqMedia from "../../FaqMedia"







import AppsChecklist from "../../AppsChecklist"






// MD UI Dashboard PRO React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import DataTable from 'examples/Tables/DataTable'
import AppData from './components/data'
import ImageCreateModal from './components/Modals/ImageModal'


import Widget from './components/Widget'
import Snapshot from './components/Snapshot'
import PaymentProvider from './components/PaymentProvider'
import CustomJS from './components/CustomJS'
import AppDescription from './components/AppDescription'
import ConversationProviderModal from './components/Modals/ConversationProviderModal'
import VideoCreateModal from './components/Modals/VideoModal'
import TriggerCreateModal from './components/Modals/TriggerModal'
import ActionCreateModal from './components/Modals/ActionModal'
import DocCreateModal from './components/Modals/DocsModal'
import { useEffect, useState } from 'react'
import Loader from 'examples/Loader'
import CreateModal from '../../StaffTasks/components/CreateModal'
import { useAppServices } from 'hook/services'
import CollectionsData from './components/Collections'
import AiKnwoledge from './components/AiKnwoledge'

function Default() {
  const AppService = useAppServices()

  const {
    loader,
    ImageDataTableData,
    VideoDataTableData,
    handleRefresh,
    appData,
    apps,
    TriggerDataTableData,
    ActionDataTableData,
    DocDataTableData,
    ConversationprovidersDataTableData,
    TasksTable,
    StaffTable,
    allStaff
  } = AppData()

  const [tabIndex, setTabIndex] = useState(0)
  const [app_collection, setApp_collection] = useState([])
  const [appTriggerModel, setAppTriggerModel] = useState([])
  const [app_features, setApp_features] = useState(appData?.app_features)

  const getAppCollection = async () => {
    const { response } = await AppService.AppCollections.get({
      query: `app_id=${appData?.app_id}`,
    })

    if (response) {
      setApp_collection(response.data)
    } else {
      setApp_collection([])
    }
    // setloader(false)
  }

  const GetAppTriggerModel = async () => {
    const { response, error } = await AppService.app_trigger_model.get()
    if (response) {
      setAppTriggerModel(response.data)
    } else {
      setAppTriggerModel([])
    }
  }
  const onLoad = () => {
    setApp_features(appData?.app_features)
    getAppCollection()
    GetAppTriggerModel()
  }

  useEffect(onLoad, [appData])

  // get apps collection by app_type
  const getAppsCollection = (app_type) => {
    const apps = app_collection?.filter((item) => item?.type?.includes(app_type))
    return apps
  }



  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <Card pt={6} pb={3}>
            <MDBox sx={{ width: '100%' }} p={2}>
              <MDBox mb={3}>
                <Tabs
                  value={tabIndex}
                  onChange={(e, index) => setTabIndex(index)}
                  aria-label="basic tabs example"
                >
                  <Tab label="Profiles" />
                  <Tab label="Features" />
                </Tabs>
              </MDBox>
              {tabIndex == 0 && (
                <Grid container spacing={6}>
                  <Grid item xs={12}>
                    <Card>
                      <MDBox
                        mx={2}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center  "
                      >
                        <MDTypography variant="h6" color="white">
                          App Description
                        </MDTypography>
                      </MDBox>
                      <MDBox pt={3} px={3}>
                        <AppDescription
                          handleRefresh={handleRefresh}
                          appData={appData}
                          type="location"
                          description={appData?.loc_description}
                        />
                      </MDBox>
                    </Card>
                  </Grid>

                  <Grid item xs={12}>
                    <Card>
                      <MDBox
                        mx={2}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center  "
                      >
                        <MDTypography variant="h6" color="white">
                          App Images
                        </MDTypography>
                        <ImageCreateModal handleRefresh={handleRefresh} appData={appData} />
                      </MDBox>
                      <MDBox pt={3} px={3}>
                        <DataTable table={ImageDataTableData} canSearch entriesPerPage={5} />
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12}>
                    <Card>
                      <MDBox
                        mx={2}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center  "
                      >
                        <MDTypography variant="h6" color="white">
                          App Videos
                        </MDTypography>
                        <VideoCreateModal handleRefresh={handleRefresh} appData={appData} />
                      </MDBox>
                      <MDBox pt={3} px={3}>
                        <DataTable table={VideoDataTableData} canSearch entriesPerPage={5} />
                      </MDBox>
                    </Card>
                  </Grid>
                  <Grid item xs={12}>
                    <Card>
                      <MDBox
                        mx={2}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center  "
                      >
                        <MDTypography variant="h6" color="white">
                          App Docs
                        </MDTypography>
                        <DocCreateModal handleRefresh={handleRefresh} appData={appData} />
                      </MDBox>
                      <MDBox pt={3} px={3}>
                        <DataTable table={DocDataTableData} canSearch entriesPerPage={5} />
                      </MDBox>
                    </Card>
                  </Grid>

                  {/* <Grid item xs={12}>
                    <Card>
                      <MDBox
                        mx={2}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center  "
                      >
                        <MDTypography variant="h6" color="white">
                          Tasks in {appData?.name}
                        </MDTypography>
                        <CreateModal
                          staff={allStaff}
                          apps={apps}
                          appData={appData}
                          handleRefresh={handleRefresh}
                        />
                      </MDBox>
                      <MDBox pt={3} px={3}>
                        <DataTable table={TasksTable} canSearch entriesPerPage={5} />
                      </MDBox>
                    </Card>
                  </Grid> */}

                  {/* <Grid item xs={12}>
                    <Card>
                      <MDBox
                        mx={2}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center  "
                      >
                        <MDTypography variant="h6" color="white">
                          Staff on {appData?.name}
                        </MDTypography>
                      </MDBox>
                      <MDBox pt={3} px={3}>
                        <DataTable table={StaffTable} canSearch entriesPerPage={5} />
                      </MDBox>
                    </Card>
                  </Grid> */}
                </Grid>
              )}

              {tabIndex == 1 && (
                <Grid container spacing={6}>
                  {app_features?.find((item) => item.value == 'triggers') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center  "
                        >
                          <MDTypography variant="h6" color="white">
                            App Triggers
                          </MDTypography>
                          <TriggerCreateModal
                            appCollections={getAppsCollection('triggers')}
                            handleRefresh={handleRefresh}
                            appData={appData}
                            appTriggerModel={appTriggerModel}
                          />
                        </MDBox>
                        <MDBox pt={3} px={3}>
                          <DataTable table={TriggerDataTableData} canSearch entriesPerPage={5} />
                        </MDBox>
                      </Card>
                    </Grid>
                  )}
                  {app_features?.find((item) => item.value == 'actions') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center  "
                        >
                          <MDTypography variant="h6" color="white">
                            App Actions
                          </MDTypography>
                          <ActionCreateModal
                            appCollections={getAppsCollection('actions')}
                            handleRefresh={handleRefresh}
                            appData={appData}
                          />
                        </MDBox>
                        <MDBox pt={3} px={3}>
                          <DataTable table={ActionDataTableData} canSearch entriesPerPage={5} />
                        </MDBox>
                      </Card>
                    </Grid>
                  )}
                  {app_features?.find((item) => item.value == 'conversation_providers') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center  "
                        >
                          <MDTypography variant="h6" color="white">
                            Conversation Providers
                          </MDTypography>
                          <ConversationProviderModal
                            appCollections={getAppsCollection('payment_provider')}
                            handleRefresh={handleRefresh}
                            appData={appData}
                          />
                        </MDBox>
                        <MDBox pt={3} px={3}>
                          <DataTable
                            table={ConversationprovidersDataTableData}
                            canSearch
                            entriesPerPage={5}
                          />
                        </MDBox>
                      </Card>
                    </Grid>
                  )}
                  {app_features?.find((item) => item.value == 'widget') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <MDTypography variant="h6" color="white">
                            Widget
                          </MDTypography>
                        </MDBox>
                        <Widget
                          appCollections={getAppsCollection('widget')}
                          handleRefresh={handleRefresh}
                          appData={appData}
                        />
                      </Card>
                    </Grid>
                  )}
                  {app_features?.find((item) => item.value == 'snapshot') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <MDTypography variant="h6" color="white">
                            Snapshot
                          </MDTypography>
                        </MDBox>
                        <Snapshot
                          appCollections={getAppsCollection('snapshot')}
                          handleRefresh={handleRefresh}
                          appData={appData}
                        />
                      </Card>
                    </Grid>
                  )}
                  {app_features?.find((item) => item.value == 'payment_provider') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <MDTypography variant="h6" color="white">
                            Payment Provider
                          </MDTypography>
                        </MDBox>
                        <PaymentProvider
                          appCollections={getAppsCollection('payment_provider')}
                          handleRefresh={handleRefresh}
                          appData={appData}
                        />
                      </Card>
                    </Grid>
                  )}
                  {app_features?.find((item) => item.value == 'custom_js') && (
                    <Grid item xs={12}>
                      <Card>
                        <MDBox
                          mx={2}
                          py={3}
                          px={2}
                          variant="gradient"
                          bgColor="info"
                          borderRadius="lg"
                          coloredShadow="info"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <MDTypography variant="h6" color="white">
                            Custom JS
                          </MDTypography>
                        </MDBox>
                        <CustomJS
                          appCollections={getAppsCollection('custom_js')}
                          handleRefresh={handleRefresh}
                          appData={appData}
                        />
                      </Card>
                    </Grid>
                  )}
                  {/* <Grid item xs={12}>
                     <Card>
                       <MDBox
                         mx={2}
                         py={3}
                         px={2}
                         variant="gradient"
                         bgColor="info"
                         borderRadius="lg"
                         coloredShadow="info"
                         display="flex"
                         justifyContent="space-between"
                         alignItems="center  "
                       >
                         <MDTypography variant="h6" color="white">
                           App Events
                         </MDTypography>
                         <EventCreateModal
                           handleRefresh={handleRefresh}
                           appData={appData}
                           events={events}
                         />
                       </MDBox>
                       <MDBox pt={3} px={3}>
                         <DataTable table={EventDataTableData} canSearch entriesPerPage={5} />
                       </MDBox>
                     </Card>
                   </Grid> */}
                </Grid>
              )}

              {/* {tabIndex == 2 && (
                <CollectionsData
                  app_collection={app_collection}
                  appData={appData}
                  handleRefresh={handleRefresh}
                />
              )} */}

              {/* {tabIndex == 3 && (
                <AiKnwoledge
                  app_collection={app_collection}
                  appData={appData}
                  handleRefresh={handleRefresh}
                />
              )} */}
            </MDBox>
          </Card>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>

            <AppsOnboardingCategory handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>

            <AppsOnboarding handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <AppsChecklistCategory handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>

            <AppsChecklist handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <AppsMediaCategory handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <AppsMedia handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <FaqCategory handleRefresh={handleRefresh} appData={appData} />
          </MDBox>
          <MDBox sx={{ marginTop: "20px", marginBottom: "20px" }}>
            <FaqMedia handleRefresh={handleRefresh} appData={appData} />
          </MDBox>



        </>
      )}
    </DashboardLayout>
  )
}

export default Default
